import React from "react";
import { ChangeEvent, forwardRef } from "react";
import { IMaskInput } from "react-imask";
import { InputConform, InputConformProps } from "./Input";
import { FieldMetadata, getInputProps } from "@conform-to/react";

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

export const TextMaskCustom = forwardRef<HTMLInputElement, any>(
  function TextMaskCustom(props, ref) {
    const { mask, definitions, onMaskAccept, ...other } = props;

    return (
      <IMaskInput
        {...other}
        mask={mask}
        definitions={definitions}
        inputRef={ref}
        // onAccept => quand un caractère est ajouté ou un texte collé
        onAccept={(v: string) => {
          // Appeler la fonction qui est remontée => appeler control.change(value) pour persister value avec conform
          if (onMaskAccept) {
            onMaskAccept(v);
          }
        }}
      />
    );
  },
);

type MaskInputProps = InputConformProps &
  Partial<CustomProps> & {
    mask?: string | RegExp;
    definitions?: any;
    field?: FieldMetadata<any, any, any>;
  };

export function MaskInput(props: MaskInputProps) {
  const { InputProps, mask, ...other } = props;
  return (
    <InputConform
      InputProps={{
        inputComponent: TextMaskCustom as any,
        ...(InputProps || {}),
      }}
      inputProps={{ mask: mask, definitions: props.definitions, ...(InputProps?.inputProps || {}) }}
      {...other}
    />
  );
}

export type MaskInputConformProps = MaskInputProps & {
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
};

export function MaskInputConform({ label, field, ...props }: MaskInputConformProps) {
  return (
    <MaskInput
      label={label}
      {...getInputProps(field, { type: "text" })}
      error={Boolean(field.errors)}
      helperText={field.errors}
      data-cy={field.name}
      field={field}
      {...props}
    />
  );
}
